// extracted by mini-css-extract-plugin
export default {"multiple_choice":"MultipleChoice_multiple_choice__RLvAD","unpressed":"MultipleChoice_unpressed__2xJlP","pressed":"MultipleChoice_pressed__3iH09"};